/*eslint-disable*/
import { styled, Box } from '@mui/material';

export const TableWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  paddingTop: '1rem',
  marginTop: '1rem',
}));
